import { Component, OnInit } from "@angular/core";
import { OperadoresService } from "../operadores.service";

@Component({
  selector: "app-form-worker-resume",
  templateUrl: "./resume.component.html",
})
export class TrabajadorResumeComponent implements OnInit {
  drawerRef: any;
  data?: {
    mode: "create" | "update";
    value: any;
  };
  constructor(public service: OperadoresService) {}
  // TODO add validators

  public defaults;
  public ngOnInit() {
    if (this.data) {
      this.defaults = this.data.value;
    this.loadImage();
    }
  }
  public valueImg = "";
  public loadImage() {
    this.service.image(this.defaults.IdTrabajador).subscribe(
      (str) => (this.valueImg = str),
      (err) => (this.valueImg = null),
    );
  }
}
